import styled from 'styled-components/macro';

const Heading = styled.h1`
	font-size: 2.75rem;
	font-weight: bold;
	text-align: center;
	color: ${({ theme }) => theme.color.blackColor};
	text-transform: capitalize;

	span {
		color: ${({ theme }) => theme.color.secondaryColor};
	}

	@media screen and (min-width: 2000px) {
		font-size: 4rem;
	}

	@media screen and (max-width: 450px) {
		font-size: 2rem;
	}
`;

export default Heading;
